import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BreadcrumbsComponent, IconComponent, PageHeaderComponent, TabComponent, TabGroupComponent } from '@pansa/ui';
import { HelpEnglishComponent } from '../help-english/help-english.component';
import { HelpPolishComponent } from '../help-polish/help-polish.component';

@Component({
  selector: 'rqa-help',
  imports: [PageHeaderComponent, BreadcrumbsComponent, IconComponent, TabComponent, TabGroupComponent, HelpEnglishComponent, HelpPolishComponent],
  templateUrl: './help.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class HelpComponent {
    selectedTab: 'polish' | 'english' = 'polish';

    onTabSelect(event: any): void {
      this.selectedTab = event;
    }
}
